"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.superagentError = exports.ensureOne = exports.api = void 0;
const superagent = __importStar(require("superagent"));
const lodash_1 = require("lodash");
const error_1 = require("./error");
const api = (host, auth) => {
    const get = (url) => __awaiter(void 0, void 0, void 0, function* () {
        const { body } = yield superagent.get(url).set('Authorization', auth);
        return body;
    });
    return {
        getUser: (id) => get(`${host}/api/idp/get-user/${id}`)
    };
};
exports.api = api;
/**
 * ensureOne
 * @description - take an array of objects and validate that there is only one
 * entry in the array, throws if multipe objects are found
 * @returns - the object or item in the array if it is the only one
 * @param {Array} items - an array of items
 * @param {string} [descrip] - name of the items (used in throw errors)
 * @param {boolean} [allowNone=false] - if true, will not throw on an empty array
 */
const ensureOne = (items, descrip, allowNone = false) => {
    if (!allowNone && (!items || items.length == 0)) {
        throw Error(`Could not find ${descrip}`);
    }
    else if (items.length > 1) {
        throw Error(`Found multiple ${descrip}`);
    }
    return (0, lodash_1.first)(items);
};
exports.ensureOne = ensureOne;
const isError = (error) => {
    if ((0, lodash_1.has)(error, 'message')) {
        return true;
    }
    return false;
};
const SEARCHES = [
    'response.body',
    'response.body.error',
    'response.error'
];
const EXTRA = [
    { from: 'response.header.x-request-id', to: 'x-request-id' }
];
const superagentError = (error) => {
    const embeddedPath = SEARCHES.find(search => isError((0, lodash_1.get)(error, search)));
    if (embeddedPath) {
        const embedded = (0, error_1.serializeError)((0, lodash_1.get)(error, embeddedPath));
        for (var extra of EXTRA) {
            if ((0, lodash_1.has)(error, extra.from)) {
                (0, lodash_1.set)(embedded, extra.to, (0, lodash_1.get)(error, extra.from));
            }
        }
        return embedded;
    }
    return (0, error_1.serializeError)(error);
};
exports.superagentError = superagentError;
//# sourceMappingURL=api.js.map